var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.0001,
    height: 32.0001,
    rx: 16,
    fill: "#E2E2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 17.5999C18.2093 17.5999 20.0001 15.809 20.0001 13.5999C20.0001 11.3907 18.2093 9.59985 16.0001 9.59985C13.791 9.59985 12.0001 11.3907 12.0001 13.5999C12.0001 15.809 13.791 17.5999 16.0001 17.5999ZM16.0001 17.5999C12.4655 17.5999 9.6001 19.7489 9.6001 22.3999M16.0001 17.5999C19.5347 17.5999 22.4001 19.7489 22.4001 22.3999",
    stroke: "#5F6D7E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatarIcon);
export default __webpack_public_path__ + "static/media/UserAvatarIcon.8a49cb6f910a04bffa008d8611832675.svg";
export { ForwardRef as ReactComponent };